export function CanvasHint() {
  return (
    <div className="canvas-hint">
      SCROLL TO PAN · ⌘ + SCROLL TO ZOOM · CLICK A NODE
    </div>
  );
}

export default CanvasHint;
